<template>
  <div>
    <datepicker
      :required="required"
      @input="send"
      input-class="form-control form-control-sm"
      v-model="post"
      :minimumView="'year'"
      :maximumView="'year'"
      :initialView="'year'"
      format="yyyy"
    ></datepicker>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  props: ["name", "validation", "content"],
  data() {
    return {
      post: '',
      phrases: {
        ok: "Pilih",
        cancel: "Batal",
      },
    };
  },
  mounted() {
    if (this.content != '' && this.content != null) {
      let year = new Date(this.content, 1, 1)
      this.post = year
    }
  },
  watch: {
    content:function(){
      if (this.content != '' && this.content != null) {
        let year = new Date(this.content, 1, 1)
        this.post = year
      }
    }
  },
  components: {
    Datepicker,
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
  },
  methods: {
    send() {
      if (this.post != "") {
        var arm = this.$moment(this.post).format("YYYY");
      }

      this.$emit("post", {
        name: this.name,
        value: arm,
      });
    },
  },
};
</script>